<template>
    <div
        class="column mb-2"
        :class="classes"
    >
        <div
            class="card card-clickable"
            @click.prevent="showModal()"
        >
            <div class="card-content">
                <b-button
                    rounded
                    size="is-small"
                    class="is-pulled-right is-size-7"
                >
                    View
                </b-button>

                <p class="title mb-1 is-6">
                    {{ note.strLinkType }}
                </p>

                <p class="subtitle mt-1 is-7">
                    <b-tooltip
                        position="is-right"
                        :label="note.dteRegisteredDate | timeAgo"
                    >
                        <small class="is-size-7 has-text-grey">
                            {{ note.dteRegisteredDate | formatDateTime }}
                        </small>
                    </b-tooltip>
                </p>

                <p class="has-text-grey">
                    {{ note.memNote | truncate(45) }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import NoteModal from './NoteModal.vue';

export default {
    props: {
        note: {
            type: Object,
            required: true,
        },
        classes: {
            type: String,
            default: 'is-12',
        },
    },

    methods: {
        showModal() {
            this.$buefy.modal.open({
                parent: this,
                component: NoteModal,
                hasModalCard: true,
                props: {
                    note: this.note,
                },
            });
        },
    },
};
</script>
